/** @format */

import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconChevronUp,
	homefieldIconNatureHot,
	homefieldIconTimeAlarmOn
} from '@dsg-tech/homefield-angular-icons';

import { BreadcrumbCategoryComponent } from '../breadcrumb-category/breadcrumb-category.component';
import { CategoryHeaderComponent } from './category-header.component';
import { CategoryHeaderWithDealsComponent } from './category-header_deals.component';
import { CommonModule } from '@angular/common';
import { DealBlockComponent } from '../deal-block/deal-block.component';
import { MarketingWidgetsModule } from '../marketing-widgets/marketing-widgets.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { MediaModule } from '@shared/media/components';
import { NgModule } from '@angular/core';
import { StripSpecialCharsPipe } from '@shared/utils/pipes';
import { WindowModule } from '@shared/data-access/services';

@NgModule({
	declarations: [
		BreadcrumbCategoryComponent,
		CategoryHeaderComponent,
		CategoryHeaderWithDealsComponent,
		DealBlockComponent
	],
	exports: [CategoryHeaderComponent, CategoryHeaderWithDealsComponent],
	imports: [
		CommonModule,
		HomefieldIconLibraryModule,
		MarketingWidgetsModule,
		MatExpansionModule,
		MediaModule,
		StripSpecialCharsPipe,
		WindowModule
	]
})
export class CategoryHeaderModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconChevronUp,
			homefieldIconNatureHot,
			homefieldIconTimeAlarmOn
		]);
	}
}
